import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Radio from '@material-ui/core/Radio';

function PaymentDocTypeRadio(props) {
  const { DocType, setDocType, bpId } = props;
  return (
    <GridContainer>
      <GridItem>
        <FormControlLabel
          label="Proveedor"
          disabled={bpId != 0}
          control={<Radio checked={DocType === 'S'} onClick={() => setDocType('S')} />}
        />
        <FormControlLabel
          label="Cliente"
          disabled={bpId != 0}
          control={<Radio checked={DocType === 'C'} onClick={() => setDocType('C')} />}
        />
        <FormControlLabel
          label="Cuenta"
          disabled={bpId != 0}
          control={<Radio checked={DocType === 'A'} onClick={() => setDocType('A')} />}
        />
      </GridItem>
    </GridContainer>
  );
}

export default PaymentDocTypeRadio;
